import React from 'react';
import { FadeIn } from './FadeIn';
export function RevelationSection() {
  return <section className="py-6 md:py-20 px-4 bg-gray-50 border-y border-gray-200" data-id="element-164">
      <div className="max-w-4xl mx-auto text-center" data-id="element-165">
        <FadeIn data-id="element-166">
          <h2 className="font-display font-black text-2xl md:text-5xl text-gray-900 mb-3 md:mb-8" data-id="element-167">
            No necesitás más fuerza de voluntad.{' '}
            <span className="text-celeste" data-id="element-168">Necesitás un plan.</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-169">
          <p className="text-lg md:text-2xl text-gray-700 font-medium leading-relaxed max-w-3xl mx-auto" data-id="element-170">
            La fuerza de voluntad se agota. Un sistema paso a paso, no. Con este
            método vas a aprender a hackear los disparadores, reemplazar el
            gesto y blindar tu decisión para que no sea un sacrificio, sino una
            liberación.
          </p>
        </FadeIn>
      </div>
    </section>;
}